import { Component, EventEmitter, Input, OnInit, Output  } from '@angular/core';

@Component({
    selector: 'app-countdown-timer',
    templateUrl: './countdown-timer.component.html',
    styleUrls: ['./countdown-timer.component.css'],
    standalone: false
})
export class CountdownTimerComponent implements OnInit {
  @Input() minutes: number = 0; // Initial time in minutes

  @Output() countdownFinished = new EventEmitter<void>();

  seconds: number = 0; // Seconds left

  private interval: any;

  ngOnInit(): void {
    this.startCountdown();
  }

  startCountdown() {
    // Convertir los minutos a segundos
    let totalTimeInSeconds = this.minutes * 300;

    this.interval = setInterval(() => {
      if (totalTimeInSeconds > 0) {
        totalTimeInSeconds--;
        this.minutes = Math.floor(totalTimeInSeconds / 60);
        this.seconds = totalTimeInSeconds % 60;
      } else {
        clearInterval(this.interval);
        this.countdownFinished.emit();
      }
    }, 1000);
  }
}
